import type { PodMallUserEntity as UserEntity } from '@mathflat/domain/@entities/PODMall/User/dto'

export class UserParams
  implements
    Pick<
      UserEntity.User,
      | 'deliveryAddress'
      | 'deliveryAddressDetail'
      | 'deliveryZipCode'
      | 'deliveryRecipientName'
      | 'deliveryRecipientEmail'
      | 'deliveryRecipientPhoneNumber'
      | 'deliveryMemo'
    >
{
  deliveryAddress: string
  deliveryAddressDetail: string
  deliveryZipCode: string
  deliveryRecipientName: string
  deliveryRecipientEmail: string
  deliveryRecipientPhoneNumber: string
  deliveryMemo: string

  constructor(data: UserEntity.User) {
    this.deliveryAddress = data.deliveryAddress
    this.deliveryAddressDetail = data.deliveryAddressDetail
    this.deliveryZipCode = data.deliveryZipCode
    this.deliveryRecipientName = data.deliveryRecipientName
    this.deliveryRecipientEmail = data.deliveryRecipientEmail
    this.deliveryRecipientPhoneNumber = data.deliveryRecipientPhoneNumber
    this.deliveryMemo = data.deliveryMemo
  }
}
